(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39250],{

/***/ 73955:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoice",
      function () {
        return __webpack_require__(66865);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Invoice; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/partials/TradlyFooter.js + 4 modules
var TradlyFooter = __webpack_require__(48777);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/settings/BillingPanel.js


function BillingPanel() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-grow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-2xl text-gray-800 font-bold mb-4",
                                children: "Billing & Invoices"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    "This workspace’s Basic Plan is set to ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "font-medium",
                                        children: "$34"
                                    }),
                                    " per month and will renew on ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "font-medium",
                                        children: "July 9, 2021"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-xl leading-snug text-gray-800 font-bold mb-1",
                                children: "Billing Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "md:flex md:justify-between md:items-center py-3 border-b border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray-800 font-medium",
                                                children: "Payment Method"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-gray-800ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-3",
                                                        children: "Mastercard ending 9282"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                        href: "#0",
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "md:flex md:justify-between md:items-center py-3 border-b border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray-800 font-medium",
                                                children: "Billing Interval"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-gray-800ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-3",
                                                        children: "Annually"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                        href: "#0",
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "md:flex md:justify-between md:items-center py-3 border-b border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray-800 font-medium",
                                                children: "VAT/GST Number"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-gray-800ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-3",
                                                        children: "UK849700927"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                        href: "#0",
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "md:flex md:justify-between md:items-center py-3 border-b border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray-800 font-medium",
                                                children: "Your Address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-gray-800ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-3",
                                                        children: "34 Savoy Street, London, UK, 24E8X"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                        href: "#0",
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "md:flex md:justify-between md:items-center py-3 border-b border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm text-gray-800 font-medium",
                                                children: "Billing Address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-sm text-gray-800ml-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mr-3",
                                                        children: "hello@Tradly.com"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                        href: "#0",
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-xl leading-snug text-gray-800 font-bold mb-1",
                                children: "Invoices"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "table-auto w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        className: "text-xs uppercase text-gray-400",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "flex flex-wrap md:table-row md:flex-no-wrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "w-full block md:w-auto md:table-cell py-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold text-left",
                                                        children: "Year"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "w-full hidden md:w-auto md:table-cell py-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold text-left",
                                                        children: "Plan"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "w-full hidden md:w-auto md:table-cell py-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold text-left",
                                                        children: "Amount"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    className: "w-full hidden md:w-auto md:table-cell py-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold text-right"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: "flex flex-wrap md:table-row md:flex-no-wrap border-b border-gray-200 py-2 md:py-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left font-medium text-gray-800",
                                                            children: "2021"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left",
                                                            children: "Basic Plan - Annualy"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left font-medium",
                                                            children: "$349.00"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-right flex items-center md:justify-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                                    href: "#0",
                                                                    children: "HTML"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block w-px h-4 bg-gray-200 mx-2",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                                    href: "#0",
                                                                    children: "PDF"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                className: "flex flex-wrap md:table-row md:flex-no-wrap border-b border-gray-200 py-2 md:py-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left font-medium text-gray-800",
                                                            children: "2020"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left",
                                                            children: "Basic Plan - Annualy"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-left font-medium",
                                                            children: "$349.00"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: "w-full block md:w-auto md:table-cell py-0.5 md:py-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-right flex items-center md:justify-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                                    href: "#0",
                                                                    children: "HTML"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block w-px h-4 bg-gray-200 mx-2",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "font-medium text-indigo-500 hover:text-indigo-600",
                                                                    href: "#0",
                                                                    children: "PDF"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col px-6 py-5 border-t border-gray-200",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex self-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn border-gray-200 hover:border-gray-300 text-gray-600",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn bg-indigo-500 hover:bg-indigo-600 text-white ml-3",
                                children: "Save Changes"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var settings_BillingPanel = (BillingPanel);

;// CONCATENATED MODULE: ./src/pages/invoice.js




function Invoice() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Build and Launch a education marketplace like Coursera, Udemy "
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly - Build and Launch a education marketplace like Coursera, Udemy "
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Tradly - Build and Launch a education marketplace like Coursera, Udemy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " bg-[#f1f5f9] flex flex-col min-h-screen overflow-hidden ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-grow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " max-w-6xl mx-auto pt-20 mb-20 space-y-20 overflow-hidden sm:pt-32 sm:mb-32 sm:space-y-32 md:pt-40 md:mb-40 md:space-y-40 px-8 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " shadow-lg rounded-sm mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(settings_BillingPanel, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TradlyFooter/* default */.Z, {})
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48777,49774,92888,40179], function() { return __webpack_exec__(73955); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);